import initPushTasks from './push';

/**
 * 初始化门店相关后台任务
 */
export default () => {
    initPushTasks();
};
